import React, { createContext } from 'react';

const PatientIDContext = createContext("");

export {
    PatientIDContext
}

